import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* Styles */
import "../../style/pages/valuation/step_1.css";
//@ts-ignore
import { encodeCookie, decodeCookie, removeCookie } from "@utils/CookieUtils";
//@ts-ignore
import PublicUserMenu from "../vue/PublicUserMenu.vue";
import axios from "axios";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import CommonModals from "../vue/CommonComponents/CommonModals";
//@ts-ignore
import { Modals } from "../Types/Modals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import TrendBanner from "../vue/TrendBanner.vue";
//@ts-ignore
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import { getPlacesAddressAutocomplete, guessZone } from "@services/geographyAPI";
//@ts-ignore
import { getPlaceFromGAutocomplete } from "@utils/GAutocompleteUtils";
//@ts-ignore
import { CONTRACT } from "@customTypes/ContractEnum";
//@ts-ignore
import { useUtilities } from "@wkComposables/useUtilities";
//@ts-ignore
import { getUserPosition } from "@utils/GeolocationUtils";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import { reverseGeocoding } from "@services/googleMapsAPI";
import { createApp, defineAsyncComponent } from "vue";
import { mapActions, mapState, createPinia } from "pinia";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
import { BaseAccordionItem } from "@wikicasa-dev/components";
import "@wikicasa-dev/components/style";
var publicValuationCookie;
var TABTYPE;
(function (TABTYPE) {
  TABTYPE["VALUATE"] = "valuate-tab";
  TABTYPE["SALE"] = "sale-tab";
})(TABTYPE || (TABTYPE = {}));
var step1App = createApp({
  name: "ValuationStep1",
  components: Object.assign(Object.assign({
    IntersectionObservableVue,
    IntersectionObserverVue,
    BaseAccordionItem,
    PublicUserMenu,
    TrendBanner,
    BaseButton,
    BaseAutocomplete,
    BaseAlert,
    //@ts-ignore
    cchart: defineAsyncComponent(() => import("@vueEntry/cchart.vue")),
    //@ts-ignore
    "base-bt-modal": defineAsyncComponent(() => import("../vue/BaseBtModal.vue")),
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(() => import("@vueEntry/UIKitComponents/BaseDropDown.vue"))
  }, LanguageIcons), CommonModals),
  setup() {
    var {
      isAppBannerVisible
    } = useAppBanner();
    var {
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick
    } = useFirebaseMessaging();
    var {
      redirectTo
    } = useUtilities();
    var {
      isLarge
    } = useBreakpoints();
    useTrustpilotWidget();
    return {
      isLarge,
      isAppBannerVisible,
      //useFirebaseMessaging
      showFirebaseSnackbar,
      snackbarTitle,
      snackbarBody,
      snackbarIcon,
      handleOnForegroundNotificationClick,
      redirectTo
    };
  },
  data() {
    return {
      disableCb: true,
      hasPlace: false,
      locationBtnDisabled: false,
      writeByUser: undefined,
      writing: false,
      textError: false,
      showUsePositionButton: false,
      valuationNumber: 0,
      lat: 0,
      long: 0,
      place: JSON.parse(window._place),
      contract: CONTRACT.SALE,
      isPositionRetrievingLoading: false,
      activeTab: TABTYPE.SALE,
      valuationGuideUrl: "https://www.wikicasa.it/news/valutare-casa-online-guida-valutazione-immobile/",
      sellingGuideUrl: "https://www.wikicasa.it/news/come-vendere-casa-privato-agenzia-immobiliare/",
      isSelling: null,
      graphData: [],
      isLoading: false
    };
  },
  computed: Object.assign(Object.assign(Object.assign({
    isDesktop() {
      return Math.min(window.screen.width, window.screen.height) > 640;
    },
    redirectUrl() {
      return window["_redirectURL"];
    },
    valuationAddressInput() {
      return document.getElementById("field1");
    },
    hasValue() {
      return !!this.writeByUser && this.writing;
    },
    getNumOfValuation() {
      return Number(window["_valuationCount"]).toLocaleString("it-It", {
        maximumFractionDigits: 2
      });
    },
    labels() {
      return window["_labels"];
    },
    isValuationActive() {
      return this.isActive("valuation-tab");
    },
    isSellingActive() {
      return this.isActive("sell-tab");
    }
  }, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
  created() {
    this.isSelling = window.fromSale;
    this.initPublicUserMenu();
    if (this.isSelling) this.setActiveTab("sell-tab");else this.setActiveTab("valuation-tab");
  },
  mounted() {
    var _a;
    publicValuationCookie = decodeCookie("publicValuationCookie");
    if (window["_invalid"]) this.setShowModal(Modals.valuationNotAvailableModal);
    removeCookie("publicValuationCookie");
    removeCookie("publicValuationRequestCookie");
    if ((_a = this.place) === null || _a === void 0 ? void 0 : _a.placeID) this.initChart(true);
  },
  methods: Object.assign(Object.assign({
    isActive(tabElement) {
      return this.activeTab === tabElement;
    },
    setActiveTab(tabElement) {
      this.activeTab = tabElement;
    },
    setValuationCookie(realEstateValuation) {
      publicValuationCookie = {
        privateValuation: true,
        realEstateValuation: {
          sale: true,
          cityID: realEstateValuation.cityID,
          macroTypologyID: 1,
          typologyID: 1,
          address: realEstateValuation.address || "",
          streetName: realEstateValuation.streetName,
          latitude: realEstateValuation.latitude,
          longitude: realEstateValuation.longitude
        }
      };
    },
    onInputChangeCb(query) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!query) return;
        var res = yield getPlacesAddressAutocomplete(query, 10);
        return res.map(r => ({
          label: r.description,
          id: r.place_id
        }));
      });
    },
    optionSelectedCb(selectedEl) {
      return __awaiter(this, void 0, void 0, function* () {
        this.disableCb = true;
        var {
          place,
          address
        } = yield getPlaceFromGAutocomplete("".concat(selectedEl.id), selectedEl.label);
        this.locationBtnDisabled = false;
        if (!place) {
          this.hasPlace = false;
          return;
        }
        this.hasPlace = true;
        this.writing = false;
        this.setValuationCookie({
          sale: true,
          cityID: place.cityID,
          address: address,
          streetName: place.streetName,
          latitude: place.latitude,
          longitude: place.longitude
        });
      });
    },
    submit() {
      this.isLoading = true;
      publicValuationCookie.realEstateValuation.isSelling = this.isSellingActive;
      encodeCookie("publicValuationCookie", publicValuationCookie);
      window.location.href = window["_nextURL"];
    },
    getCurrentPosition() {
      var _a;
      this.isPositionRetrievingLoading = true;
      (_a = getUserPosition()) === null || _a === void 0 ? void 0 : _a.then(res => {
        if (res) {
          this.lat = res.coords.latitude;
          this.long = res.coords.longitude;
          this.textError = false;
          this.retrieveAddressFromCoords(this.lat, this.long);
        } else {
          this.textError = true;
        }
      }).catch(error => {
        console.error(error);
        //The user denied Geolocation
        if ((error === null || error === void 0 ? void 0 : error.code) == 1) this.textError = true;
        this.isPositionRetrievingLoading = false;
      }).finally(() => setTimeout(() => {
        this.textError = false;
      }, 5000));
    },
    retrieveAddressFromCoords(lat, long) {
      reverseGeocoding(lat, long).then(reverseRes => {
        //check if the address is in italy if it is not then return
        if (!reverseRes.data || !reverseRes.data.plus_code.compound_code.includes("Italia") && !reverseRes.data.plus_code.compound_code.includes("Italy")) return;
        guessZone(lat, long).then(resGuessZone => {
          var placeN = resGuessZone;
          placeN.address = reverseRes.data.results[0].formatted_address;
          placeN.description = reverseRes.data.results[0].formatted_address;
          this.hasPlace = true;
          this.writing = false;
          this.place = placeN;
          this.hasPlace = true;
          this.disableCb = true;
          this.writeByUser = {
            label: placeN.address
          };
          this.setValuationCookie({
            sale: true,
            cityID: placeN.cityID,
            address: placeN.address,
            streetName: placeN.streetName,
            latitude: placeN.latitude,
            longitude: placeN.longitude
          });
        });
      }).catch().finally(() => {
        this.locationBtnDisabled = false;
        this.isPositionRetrievingLoading = false;
      });
    },
    openTopCities(e) {
      this.$refs.containerTopCities.classList.remove("top-cities-collapsed");
      this.$refs.buttonTopCities.classList.remove("d-flex");
      this.$refs.buttonTopCities.classList.add("d-none");
    },
    setContract(contract) {
      if (contract == CONTRACT.SALE) {
        this.contract = CONTRACT.SALE;
        this.initChart(true);
      } else if (contract == CONTRACT.RENT) {
        this.contract = CONTRACT.RENT;
        this.initChart(false);
      }
    },
    initChart(sale) {
      return __awaiter(this, void 0, void 0, function* () {
        var res = yield axios.post("/rest/statistics/getValuationPriceGraphData?sale=".concat(sale), this.place);
        this.graphData = res.data;
      });
    },
    closeValuationAvailableModal() {
      this.setShowModal(Modals.noModal);
      history.pushState({}, "", this.redirectUrl);
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["logout", "initPublicUserMenu"]))
});
step1App.use(createPinia());
step1App.mount("#step1-main");